import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import ThemeProvider from 'react-bootstrap/ThemeProvider';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { Spinner, Alert } from 'react-bootstrap';
import './login.css';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from "react-redux";
import { sendPasswordResetOtp } from "./passwordAction";
import { updatePassword } from "./passwordAction";

function Copyright(props) {
  return (
    <p className="mt-3 mb-3" variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <a color='inherit' href='#'>
        Royal Arabian Tours
      </a>{' '}
      {new Date().getFullYear()}
      {'.'}
    </p>
  );
}

const initialState={
    pin:"",
    password: "",
    confirmPass: "",
}

const passVerificationError = {
    isLenthy: false,
    hasUpper: false,
    hasLower: false,
    hasNumber: false,
    hasSpeclChr: false,
    confirmPass: false
};

 const UpdatePasswordForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [newPassword, setNewPassword] = useState(initialState);
  const [passwordError, setPasswordError] = useState(passVerificationError);
  const [emails, setEmails] = useState("");

 // const[email, setEmail] = useState("");

  const {isLoading, status, message, email,successupdate} = useSelector(state => state.passwordReset);

  useEffect(() => {
   setEmails(email);
  }, []);

  useEffect(() => {
    if (successupdate === "success") {
  
      setTimeout(() => {
        navigate('/');
      }, 2000);
    }
  }, [successupdate, navigate]);


  const handleOnSubmit = e => {
    e.preventDefault();
   const {pin,password,confirmPass} = newPassword;

    const newPassObj= {
        otp:pin,
        password: password,
        confirmpassword: confirmPass,
        email:emails
    }
    dispatch(updatePassword(newPassObj));
  };
  
  const handleOnChange = e => {
   const {name, value} = e.target;

   setNewPassword({...newPassword, [name]: value });

   if(name === "password"){
    const isLenthy = value.length > 8;
    const hasUpper = /[A-Z]/.test(value);
    const hasLower = /[a-z]/.test(value);
    const hasNumber = /[0-9]/.test(value);
    const hasSpeclChr = /[@,#,$,%,&]/.test(value);
    setPasswordError({
        ...passwordError,
        isLenthy,
        hasUpper,
        hasLower,
        hasNumber,
        hasSpeclChr
    });
   }

   if(name === "confirmPass"){
    setPasswordError({
        ...passwordError,
        confirmPass: newPassword.password === value,
    });
   }
  };




  return (
    <div className="login-container-fluid">
      <Row>
        <Col xs lg="7" className="resetPassword-bg"><div></div></Col>
        <Col xs lg="5">

          <div className="forgot-second-col">
            <img
              src='/images/RATourlogo.webp'
              srcSet='/images/RATourlogo.webp'
              alt='Royalarabian Tours'
              loading="lazy"

            />
            <ThemeProvider
              breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs']}
              minBreakpoint="xxs"
            >
              <form className=" mt-5" component="form" autoComplete="off" noValidate onSubmit={handleOnSubmit}>
                <h4 className="sign-in">Reset Password!</h4>
               
                {message && (
                <Alert variant={status === "success" ? "success" : "danger"}>
                  {message}
                  </Alert>
              )}
              {isLoading && <Spinner variant="primary" animation="border" />}
                <Form.Floating className="mb-3 mt-5">
                  <Form.Control
                  id="floatingInputCustom"
                    name="pin"
                    value={newPassword.pin}
                    onChange={handleOnChange}
                    placeholder="OTP"
                    required
                  />
                  <label htmlFor="floatingInputCustom">OTP</label>
                </Form.Floating>

                <Form.Floating className="mb-3 mt-5">
                  <Form.Control
                    id="floatingInputCustom"
                    autoFocus
                    type="password"
                    name="password"
                    value={newPassword.password}
                    onChange={handleOnChange}
                    placeholder="Password"
                    required
                   
                  />
                  <label htmlFor="floatingInputCustom">Change Password</label>
                </Form.Floating>

                <Form.Floating className="mb-3 mt-5">
                  <Form.Control
                    id="floatingInputCustom"
                    autoFocus
                    type="password"
                    name="confirmPass"
                    value={newPassword.confirmPass}
                    //onChange={handleOnChange}
                    onChange={handleOnChange}
                    placeholder="Confirm Password"
                    required
                   
                  />
                  <label htmlFor="floatingInputCustom">Confirm Password</label>
                </Form.Floating>
                <Form.Text>
                    {!passwordError.confirmPass && (
                        <div className="text-danger mb-3">Password doesn't match</div>
                    )}
                </Form.Text>

                <ul className="mab-4">
                    <li className={
                        passwordError.isLenthy ? "text-success" : "text-danger"
                    }> Min 8 Characters</li>
                    <li 
                    className={
                        passwordError.hasUpper ? "text-success" : "text-danger"
                    
                    }>
                        At least one upper case
                    </li>
                    <li 
                    className={
                        passwordError.hasLower ? "text-success" : "text-danger"
                    }>
                        At least on lower case
                    </li>
                    <li 
                    className={
                        passwordError.hasNumber ? "text-success" : "text-danger"
                    }
                    >
                        At least one number
                    </li>
                    <li 
                    className={
                        passwordError.hasSpeclChr ? "text-success" : "text-danger"
                    }
                    >
                        At least one of the special characters i.e @ # $ % & {" "}
                    </li>
                </ul>
           
           

                <div className="d-grid">
                  <button type="submit" className="btn btn-primary" disabled={Object.values(passwordError).includes(false)}>
                    Submit
                  </button>
                  
                </div>
                
              </form>
              <hr />
              <br />
              <Copyright />
            </ThemeProvider>
          </div>
        </Col>
      </Row>

    </div>
  );
};

export default UpdatePasswordForm;

